import './GradeLinkRenderer.scss';
import { LinkNewTab } from 'common/components/LinkNewTab/LinkNewTab';
import { Score } from 'common/components/score/Score';


export function GradeLinkRenderer(props: any) {
  if (!props?.formattedValue) {
    return <></>
  }
  const getLink = () => {
    return `/pages/assessments/orgScore?account=${props.id}`
  }
  return (
    <LinkNewTab
      to={getLink()}
      className="grade-link-renderer"
      text={
        <Score
          value={props.formattedValue?.score}
          label={props.formattedValue?.grade.toUpperCase()}
          size="small"
          className="grade-link-renderer"
        />
      }
    />
  );
}
